import React, { FunctionComponent } from "react";
import styles from "./ProjectDocumentModal.module.css";
import { IoMdDocument } from "react-icons/io";
// import { uploadProjectResources } from "../../../Services/resources";
import { uploadProjectResources } from "../../../Services/projects";
import { connect, useDispatch } from "react-redux";
import {themeColors} from "../../theme";
import { motion } from "framer-motion";
import Backdrop from "../../Backdrop/Backdrop";
import { showSnackbarAction } from "../../../Redux/actions";

type props = {
  open: boolean;
  close: () => void;
  title: string;
setLoad:(data:boolean)=>void;
  projectData: any;
  type: string;
  theme: any;
  userPreference: any;
  user: any;
};

const dropIn = {
  hidden: {
    y: "-100vh",
    opacity: 1,
  },
  visible: {
    y: "0",
    opacity: 1,
    transition: {
      duration: 1,
      type: "spring",
      damping: 25,
      stiffness: 500,
    },
  },
};


const ProjectDocumentModal: FunctionComponent<props> = ({
  open,
  close,
  title,
setLoad,
  projectData,
  type,
  theme,
  userPreference,
  user
}) => {
  const dispatcher = useDispatch();
  
  const upload = async (file: any) => {
    if (userPreference.project_attachments_create_approved === false) {
      dispatcher(
        showSnackbarAction(
          "You are not allowed to add attachment. Contact your admin",
          "error"
        )
      );
    } else {
      let name: any = document.getElementById("file-input");
      let nameList = name.value.split("\\");
      let fileName = nameList[nameList.length - 1];
      close();
      setLoad(true);
      await uploadProjectResources(
        file[0],
        projectData,
        type,
        fileName,
        dispatcher,
      );
      setLoad(false);
    }
  };
  const containerStyles ={ backgroundColor:theme ? themeColors.backgroundColor:themeColors.backgroundColorDark,color:theme ? themeColors.textPrimary:themeColors.textPrimaryDark} 
  return (
    <>
      <Backdrop>
      <motion.div
        key="modal"
        className="card p-4 shadow rounded"
        style={{position: "absolute",
        ...containerStyles}}
        variants={dropIn}
        initial="hidden"
        animate="visible"
        exit="exit"
      >
      
      <h6 
      // className={styles.title}
      >{title}</h6>
      <div
        className={styles.dragBox}
        onDragOver={(e) => {
          e.preventDefault();
        }}
        onDrop={(e) => {
          e.preventDefault();
          upload(e.dataTransfer.files);
        }}
      >
        <IoMdDocument size={80} color={"#808080"} />
        <p>Drag And Drop</p>
      </div>

      <div className={styles.buttonContainer}>
        <button className={styles.cancelButton} onClick={close}>
          Cancel
        </button>
        <div className={styles.selectBox}>
          <label htmlFor="file-input" className={styles.uploadButton}>
            Upload File
          </label>
          {title==="Brochures Document"?
          <input
          id="file-input"
          className={styles.select}
          type="file"
          accept='.jpg, .jpeg, .png,.pdf'
          onChange={(e: any) => upload(e.target.files)}
        />:<input
            id="file-input"
            className={styles.select}
            type="file"
            accept='.jpg, .jpeg, .png,.pdf,.doc,.docx,.ppt,.pptx'
            onChange={(e: any) => upload(e.target.files)}
          />}
        </div>
      </div>
      </motion.div>
      </Backdrop>
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    theme: state.theme.isLightMode,
    userPreference:state.userPreference.data,
    user: state.user.data,
  };
};

export default connect(mapStateToProps)(ProjectDocumentModal);


